import get from 'lodash/get'
import { isNumber, required, hasLength, maxLength } from '../../utils/validations'

const validate = (values: any) => {
  const bankCode = get(values, 'bankCode')
  const number = get(values, 'number')
  const prefix = get(values, 'prefix')

  return {
    bankCode: required(bankCode) || hasLength(4)(bankCode) || isNumber(bankCode),
    number: required(number) || isNumber(number) || maxLength(10)(number),
    prefix: !!prefix && (isNumber(prefix) || maxLength(6)(prefix)),
  }
}

export default validate
